import angular from 'angular'

/**
 * A clearly separated section with contrasting background and border. Often used to group a list of related content,
 * each represented as a `vd-panel-section`.
 *
 * @role region
 */
angular.module('vend.ui').directive('vdPanel', function (elementService) {
  return {
    compile(tElement, tAttrs) {
      const classes = elementService.getClasses(tElement)

      classes.push('vd-panel')

      tAttrs.$set('role', 'region')
      tAttrs.$set('class', classes.join(' '))
    },
  }
})
